window.addEventListener('load', () => {
  const moreTrs = document.querySelectorAll('.more-tr')

  if (moreTrs.length === 0) {
    return
  }

  const courseTh = document.querySelector('.course-th')
  const gradientBox = document.querySelector('.gradient-box')
  const icon = document.querySelector('.course-icon')
  const thirdCorse = document.querySelector('#third-course')

  courseTh.addEventListener('click', () => {
    icon.classList.toggle('fa-plus-circle')
    icon.classList.toggle('fa-minus-circle')
    thirdCorse.classList.toggle('third-course')
    moreTrs.forEach((moreTr) => {
      moreTr.classList.toggle('more-tr')
    })
  })

  gradientBox.addEventListener('click', () => {
    icon.classList.toggle('fa-plus-circle')
    icon.classList.toggle('fa-minus-circle')
    thirdCorse.classList.toggle('third-course')
    moreTrs.forEach((moreTr) => {
      moreTr.classList.toggle('more-tr')
    })
  })
})
